
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { CreditOverdrawnOrderDto } from "@/dtos/creditOverdrawnOrderDto";
import httpClient from "../../store/httpClient";

@Component({})
export default class CreditOverdrawnOrdersDialog extends Vue {
	@Prop()
	private paidInvoiceIds!: number[];
	private blockedOrders: CreditOverdrawnOrderDto[] = [];
	private blockedOrdersDialogOpen: boolean = false;

	private headers = [
		{ text: "Auftrags-Id", value: "orderId", align: "left", sortable: true },
		{ text: "Bestellt am", value: "orderedAt", align: "left", sortable: true },
		{ text: "Auftragsbetrag", value: "totalOfOrder", align: "right", sortable: true },
		{ text: "Vorausrechnung?", value: "prepayInvoiceWasSent", align: "left", sortable: false },
		{ text: "Bezahlt?", value: "prepayInvoiceWasPaid", align: "left", sortable: false },
		{ text: "", value: "actions", align: "right", sortable: false },
	];

	@Watch("paidInvoiceIds")
	private async markAsPaid() {
		console.log("paidInvoiceIds changed");
		if (this.paidInvoiceIds.length <= 0) {
			return;
		}
		try {
			// Check if there are blocked orders
			this.blockedOrders = [];
			for (const paidInvoiceId of this.paidInvoiceIds) {
				const blockedResponse = await httpClient().get(
					`Invoice/GetBlockedOrdersDueToCreditOverdraw?invoiceId=${paidInvoiceId}`
				);

				if (blockedResponse.data && blockedResponse.data.length > 0) {
					this.blockedOrders.push(...blockedResponse.data);
				}
			}
			this.blockedOrdersDialogOpen = true;
		} catch (e) {
			console.log("Get blocked orders failed.", e);
		}
	}

	/**
	 * Release a blocked order because the prepay invoice was paid.
	 */
	private async releaseBlockedOrder(orderId: number) {
		const call =
			`CustomerOrder/ReleaseOrder?orderId=${orderId}` +
			`&fertigerId=0` +
			`&sendConfirmation=true` +
			`&sendToCustomer=true`;
		const response = await httpClient().post(call);
		const indexOfOrder = this.blockedOrders.findIndex((o) => o.orderId == orderId);
		this.blockedOrders.splice(indexOfOrder, 1);
		this.$store.commit("setSnackbarText", `Auftrag ${orderId} wurde freigegeben.`);
		if (this.blockedOrders.length == 0) {
			// close dialog if all orders released
			this.blockedOrdersDialogOpen = false;
		}
	}
}
